<div class="transfer-container d-flex flex-column justify-content-between">
    <div class="header p-4">
        <div class="d-flex justify-content-start align-items-center" (click)="backToBeneficiarySelection()">
            <mat-icon fontIcon="arrow_back"></mat-icon>
            <span>back</span>
        </div>
        <div class="d-flex flex-column justify-content-center align-items-center my-4">
            <div class="icon">
                <mat-icon class="header-icon" svgIcon="wallet-money"></mat-icon>
            </div>
            <h2>Peer to Peer Transfer</h2>
        </div>
    </div>

    <div class="receiver-details p-2 mx-4 -my-4">
        <div class="d-flex justify-content-between align-items-center">
            <span class="receiver-details-title">Receiver Details</span>
            <!-- <div class="toggle">
                <label>Save as beneficiary</label>
                <input type="checkbox" checked />
            </div> -->
        </div>
        <div class="d-flex flex-column justify-content-center align-items-center my-2">
            <!-- <mat-icon svgIcon="user-img" class="profile-img"></mat-icon> -->
            <div>
                <p class="receiver-name d-flex justify-content-center">
                    {{ recipientInfo.first_name[0] + '*'.repeat(recipientInfo.first_name.length - 2) + recipientInfo.first_name[recipientInfo.first_name.length - 1] }}
                    {{ recipientInfo.last_name[0] + '*'.repeat(recipientInfo.last_name.length - 2) + recipientInfo.last_name[recipientInfo.last_name.length - 1] }}
                </p>
                <p class="receiver-phone d-flex justify-content-center">{{ recipientInfo.mobile }}</p>
            </div>
        </div>
    </div>

    <div class="wallet-container px-4 mt-4">
        <div class="wallet-section" [class.border-danger]="doesAmountExceedBalance || !isCurrencySame" [class.border]="doesAmountExceedBalance || !isCurrencySame">
            <div class="wallet-header d-flex justify-content-between align-items-center">
                <div class="wallet-title">Sender’s Wallet</div>
                <div class="wallet-balance">Balance: {{ balance }}</div>
            </div>
            <div class="wallet-input-group">
                <div class="currency-select">
                    <!-- <img src="assets/home/united states.svg" alt="Flag Icon" class="flag-icon" /> -->
                    <app-value-field *ngIf="senderAccounts.length > 0; else sender" [editMode]="true">
                        <app-value-field-select
                            *ngIf="form.controls.senderCurrency"
                            [controlDisplayName]="'Send Currency'"
                            [control]="form.controls.senderCurrency"
                            appValueField="editField"
                            placeholder="Select currency"
                        >
                            <ng-template *ngFor="let walletInfo of senderWalletInfo | keyvalue" [appValueFieldOption]="walletInfo.key">
                                <div class="d-flex align-items-center">
                                    <img
                                        [src]="'/assets/currency-flags/' + walletInfo.key + '-flag.svg'"
                                        [alt]="walletInfo.key"
                                        style="width: 15px; height: 15px"
                                        class="rounded-circle me-1"
                                    />
                                    <span style="font-size: 16px; margin-right: 10px">{{ walletInfo.key }}</span>
                                </div>
                            </ng-template>
                        </app-value-field-select>
                    </app-value-field>

                    <ng-template #sender>
                        <span>{{ senderAccounts[0].currencies[0] }}</span>
                        <i class="fas fa-caret-down text-success"></i>
                    </ng-template>
                </div>
                <input type="number" class="form-control amount-input" [formControl]="form.controls.sendAmount" />
            </div>
        </div>

        <div *ngIf="doesAmountExceedBalance" class="error-message" style="font-size: 13px">Insufficient balance. The entered amount exceeds your available balance.</div>
    </div>

    <textarea class="m-4 my-2 form-control w-auto" placeholder="Add a note (Optional)" [formControl]="form.controls.note"></textarea>

    <div class="footer d-flex justify-content-start align-items-center p-4 w-100">
        <button
            mat-raised-button
            class="btn-primary rounded-pill me-2"
            [class.btn-primary-disabled]="!isCurrencySame || doesAmountExceedBalance || !form.valid"
            [class.button-spinner]="loading"
            [disabled]="!isCurrencySame || doesAmountExceedBalance || loading || !form.valid"
            (click)="continueToPeerToPeerConfirmation()"
        >
            {{ loading ? '' : 'View Summary' }}
        </button>
        <button mat-raised-button class="btn-secondary rounded-pill" (click)="backToBeneficiarySelection()">Cancel</button>
    </div>
</div>
